"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JsonTable = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _jsonComponent = require("../common/jsonComponent");

var _locale = require("../locale");

var _transTablePropsChain = require("./transTablePropsChain");

var _fieldType = require("../fieldType");

var _formApi = require("../apis/formApi");

var _lodash = _interopRequireDefault(require("lodash"));

require("./index.less");

var _dec, _dec2, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var JsonTable = (_dec = (0, _vuePropertyDecorator.Component)({
  inheritAttrs: false,
  props: _objectSpread({
    actions: {
      // 'add' | 'view' | 'viewLine' | 'edit' | 'editLine' | 'delete' | 'showCols' | 'filter' | 'fullScreen' | 'export' | 'import'
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rowKey: {
      type: String,
      default: '_id'
    },
    pagination: {
      type: [Object, Boolean],
      default: undefined
    },
    showAfterLoadTasks: {
      type: Boolean,
      default: true
    },
    // 高阶用法，更改发请求的几个方法
    getData: Function
  }, _transTablePropsChain.jsonTableExtraProps)
}), _dec2 = (0, _vuePropertyDecorator.Watch)('$props.filter'), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(JsonTable, _Mixins);

  var _super = _createSuper(JsonTable);

  function JsonTable() {
    var _this;

    (0, _classCallCheck2.default)(this, JsonTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = _objectSpread(_objectSpread({}, _transTablePropsChain.jsonTableInitState), {}, {
      filter: []
    });
    _this.loading = false;
    _this.privateDataSource = [];
    _this.privatePagination = {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      showTotal: function showTotal() {
        return "".concat((0, _locale.tl)('showTable.totalPre')).concat(_this.privatePagination.total).concat((0, _locale.tl)('showTable.totalSuf'));
      },
      showQuickJumper: true,
      total: 0
    };
    _this.rid = 0;
    return _this;
  }

  (0, _createClass2.default)(JsonTable, [{
    key: "type",
    get: function get() {
      return 'table';
    }
  }, {
    key: "dataSource",
    get: function get() {
      return _fieldType.FieldType.transDataByType(this.privateDataSource, this.formItems);
    }
  }, {
    key: "factPagination",
    get: function get() {
      var privatePagination = this.privatePagination,
          dataSource = this.dataSource;
      var pagination = this.$props.pagination;

      if (pagination === undefined) {
        return privatePagination;
      }

      if (pagination === false) {
        return false;
      }

      var mergePagination = _objectSpread(_objectSpread({}, privatePagination), pagination);

      var pageNum = Math.ceil(mergePagination.total / mergePagination.pageSize);
      var pageSize = Math.max(dataSource.length, mergePagination.pageSize);
      return _objectSpread(_objectSpread({}, mergePagination), {}, {
        pageSize: pageSize,
        total: dataSource.length > mergePagination.pageSize ? pageSize * pageNum : mergePagination.total,
        showSizeChanger: mergePagination.showSizeChanger && mergePagination.pageSize >= dataSource.length || false
      });
    }
  }, {
    key: "columns",
    get: function get() {
      return _fieldType.FieldType.trans2TreeByType(this.formItems, undefined);
    }
  }, {
    key: "created",
    value: function created() {
      this.getList();
    }
  }, {
    key: "filterChange",
    value: function filterChange() {
      var _this$$props, _this$$props$paginati;

      this.privatePagination.current = 1;
      this.$emit('change', {
        current: 1,
        pageSize: (_this$$props = this.$props) === null || _this$$props === void 0 ? void 0 : (_this$$props$paginati = _this$$props.pagination) === null || _this$$props$paginati === void 0 ? void 0 : _this$$props$paginati.pageSize
      });
      this.getList();
    }
  }, {
    key: "getTableProps",
    value: function getTableProps() {
      var _this2 = this;

      var dataSource = this.dataSource,
          factPagination = this.factPagination,
          loading = this.loading,
          columns = this.columns,
          onTableChange = this.onTableChange;
      var _rowKey = this.$props.rowKey;
      var defaultProps = {
        tag: 'a-table',
        rowKey: function rowKey(record) {
          return record[_rowKey] + '_' + record._index;
        },
        dataSource: dataSource,
        loading: loading,
        columns: columns,
        childrenColumnName: '',
        pagination: factPagination,
        className: {
          'json-table': true
        },
        actions: [],
        rightActions: [],
        on: {
          change: onTableChange
        }
      };
      return _transTablePropsChain.transTablePropsChainList.reduce(function (tableProps, func) {
        return func(tableProps, _this2.$props, _this2.state, _this2);
      }, defaultProps);
    }
  }, {
    key: "getList",
    value: function () {
      var _getList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var options,
            factPagination,
            formId,
            getFormPromise,
            privatePagination,
            state,
            _this$$props2,
            showAfterLoadTasks,
            filter,
            _options$silent,
            silent,
            _options$onlyGet,
            onlyGet,
            rest,
            getData,
            pagination,
            params,
            tasks,
            cid,
            res,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                factPagination = this.factPagination, formId = this.formId, getFormPromise = this.getFormPromise, privatePagination = this.privatePagination, state = this.state;
                _this$$props2 = this.$props, showAfterLoadTasks = _this$$props2.showAfterLoadTasks, filter = _this$$props2.filter;
                _options$silent = options.silent, silent = _options$silent === void 0 ? false : _options$silent, _options$onlyGet = options.onlyGet, onlyGet = _options$onlyGet === void 0 ? false : _options$onlyGet, rest = (0, _objectWithoutProperties2.default)(options, ["silent", "onlyGet"]);
                getData = this.$props.getData || _formApi.FormApi.getPage;

                if (!silent && !onlyGet) {
                  this.privateDataSource = [];
                }

                if (!onlyGet) {
                  this.loading = true;
                } // 处理页码信息


                pagination = factPagination || {
                  current: 1,
                  pageSize: 9999
                };
                params = _lodash.default.merge({
                  authId: formId,
                  current: pagination.current,
                  size: pagination.pageSize,
                  matches: [].concat((0, _toConsumableArray2.default)(state.filter), (0, _toConsumableArray2.default)(filter))
                }, rest);
                _context.prev = 9;
                tasks = [getData(params)];
                cid = ++this.rid; // 等待 form 请求 以及 关联数据请求 完成

                if (!showAfterLoadTasks) {
                  _context.next = 16;
                  break;
                }

                _context.next = 15;
                return getFormPromise;

              case 15:
                tasks.push(Promise.race([Promise.all(this.taskList), new Promise(function (resolve) {
                  return setTimeout(resolve, 5000);
                })]));

              case 16:
                _context.next = 18;
                return Promise.all(tasks);

              case 18:
                res = _context.sent[0];

                if (!onlyGet && cid === this.rid) {
                  // 处理获取的数据
                  this.privateDataSource = res.items || [];
                  privatePagination.total = res.totalItem;
                  this.loading = false;
                }

                return _context.abrupt("return", res.items);

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](9);

              case 25:
                this.loading = false;
                return _context.abrupt("return", []);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 23]]);
      }));

      function getList() {
        return _getList.apply(this, arguments);
      }

      return getList;
    }()
    /**
     * 清空所有筛选条件，可通过ref调用
     */

  }, {
    key: "clearAllFilter",
    value: function clearAllFilter() {
      var _this$$props3, _this$$props3$paginat;

      this.state.filter = [];
      this.privatePagination.current = 1;
      this.$emit('change', {
        current: 1,
        pageSize: (_this$$props3 = this.$props) === null || _this$$props3 === void 0 ? void 0 : (_this$$props3$paginat = _this$$props3.pagination) === null || _this$$props3$paginat === void 0 ? void 0 : _this$$props3$paginat.pageSize
      });
    }
  }, {
    key: "onTableChange",
    value: function onTableChange(_ref) {
      var current = _ref.current,
          pageSize = _ref.pageSize;
      var privatePagination = this.privatePagination,
          factPagination = this.factPagination;
      var pagination = this.$props.pagination;

      if (pageSize === (factPagination === null || factPagination === void 0 ? void 0 : factPagination.pageSize)) {
        pageSize = (pagination === null || pagination === void 0 ? void 0 : pagination.pageSize) || privatePagination.pageSize;
      }

      privatePagination.current = current;
      privatePagination.pageSize = pageSize;
      this.$emit('change', {
        current: current,
        pageSize: pageSize
      });
      this.getList({});
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this$$scopedSlots$ri, _this$$scopedSlots, _this$$scopedSlots$ac, _this$$scopedSlots2, _this$$scopedSlots$to, _this$$scopedSlots3;

      var getTableProps = this.getTableProps;

      var _getTableProps = getTableProps(),
          tag = _getTableProps.tag,
          _getTableProps$action = _getTableProps.actions,
          actions = _getTableProps$action === void 0 ? [] : _getTableProps$action,
          _getTableProps$rightA = _getTableProps.rightActions,
          rightActions = _getTableProps$rightA === void 0 ? [] : _getTableProps$rightA,
          _getTableProps$on = _getTableProps.on,
          on = _getTableProps$on === void 0 ? {} : _getTableProps$on,
          className = _getTableProps.className,
          tableProps = (0, _objectWithoutProperties2.default)(_getTableProps, ["tag", "actions", "rightActions", "on", "className"]);

      var table = h(tag, {
        attrs: _objectSpread(_objectSpread({}, this.$attrs), tableProps),
        on: on,
        class: className,
        style: 'margin-top: 12px;'
      });
      var rightHeader = h('div', {
        style: 'float: right; display: inline-block;'
      }, [(_this$$scopedSlots$ri = (_this$$scopedSlots = this.$scopedSlots).rightActions) === null || _this$$scopedSlots$ri === void 0 ? void 0 : _this$$scopedSlots$ri.call(_this$$scopedSlots, this.getList)].concat((0, _toConsumableArray2.default)(rightActions)));
      var header = h('div', {
        class: 'json-table-actions clearfix'
      }, [].concat((0, _toConsumableArray2.default)(actions), [(_this$$scopedSlots$ac = (_this$$scopedSlots2 = this.$scopedSlots).actions) === null || _this$$scopedSlots$ac === void 0 ? void 0 : _this$$scopedSlots$ac.call(_this$$scopedSlots2, this.getList), rightHeader, (_this$$scopedSlots$to = (_this$$scopedSlots3 = this.$scopedSlots).top) === null || _this$$scopedSlots$to === void 0 ? void 0 : _this$$scopedSlots$to.call(_this$$scopedSlots3, this.factPagination)]));
      return h('div', {
        class: 'json-table'
      }, [header, table]);
    }
  }]);
  return JsonTable;
}((0, _vuePropertyDecorator.Mixins)(_jsonComponent.JsonComponent)), _temp), ((0, _applyDecoratedDescriptor2.default)(_class2.prototype, "filterChange", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "filterChange"), _class2.prototype)), _class2)) || _class);
exports.JsonTable = JsonTable;